module.exports = __webpack_public_path__ + "static/media/MVNZ_web_3_preview.285f7fa4.jpg";